import Vue from 'vue';

import {
 get, put, post, patch, del,
} from '../../request';

const state = () => ({
    payments: [],
    subPayments: [],
    groups: [],
    error: null,
    success: null,
    contracts: [],
    signedContracts: [],
    contractDetailInfluencers: [],
    contractDetailTotalInfluencers: null,
});

const getters = {
};

const mutations = {
    error(s, e) {
      Vue.set(s, 'error', e);
    },
    setSuccess(s, message) {
      Vue.set(s, 'success', message);
    },
    setPayments(s, payments) {
      Vue.set(s, 'payments', payments);
    },
    setSubPayments(s, subPayments) {
      Vue.set(s, 'subPayments', subPayments);
    },
    setGroups(s, groups) {
      Vue.set(s, 'groups', groups);
    },
    setContractsTemplates(s, data) {
      Vue.set(s, 'contracts', data);
    },
    setSignedContracts(s, data) {
      Vue.set(s, 'signedContracts', data);
    },
    setContractDetailInfluencers(s, influencers) {
      Vue.set(s, 'contractDetailInfluencers', influencers);
    },
    setContractDetailInfluencersTotal(s, influencersTotal) {
      Vue.set(s, 'contractDetailTotalInfluencers', influencersTotal);
    },
};

const actions = {
  async doGetPayments({ commit }) {
    commit('error', null);
    try {
      const data = await get('/payments/merchant/all', { commit });
      commit('setPayments', data.merchant_payments);
      commit('setSubPayments', data.merchant_subscription_payments);
    } catch (e) {
      commit('error', e);
    }
  },
  async doUpdateProfile({ commit }, form) {
    commit('setSuccess', null);
    commit('error', null);
    try {
      const phoneData = await patch('/user/merchant/phone_number', {
        phone_number: form.phone,
      }, { commit });
      commit('Auth/setPhoneNumber', phoneData, { root: true });

      const data = await put('/user/merchant', form, { commit });
      commit('Auth/setProfile', data, { root: true });

      if (form.agency) {
        await put('/user/merchant', form.agency, { commit });
        commit('Companies/doGetProfile', { root: true });
      }
    } catch (e) {
      commit('error', e);
    }
  },
  async doGetGroups({ commit }) {
    commit('error', null);
    try {
      const data = await get('/merchant/influencer_groups', { commit });
      commit('setGroups', data);
    } catch (e) {
      commit('error', e);
    }
  },
  async doGetContractsTemplates({ commit }) {
    commit('error', null);
    try {
      const data = await get('/contract_templates', { commit });
      commit('setContractsTemplates', data.sort((a, b) => (new Date(a.created_at) - new Date(b.created_at))));
    } catch (e) {
      commit('error', e);
    }
  },
  async doGetSignedContracts({ commit }) {
    commit('error', null);
    try {
      const data = await get('/contract_statistics', { commit });
      commit('setSignedContracts', data);
    } catch (e) {
      commit('error', e);
    }
  },
  async doGetContractInfluencers({ commit }, form) {
    const data = await post('/contract_statistics/influencers', form, { commit });
    commit('setContractDetailInfluencersTotal', data.total_count);
    commit('setContractDetailInfluencers', data.influencers);
  },
  async doExportContractInfluencersToCsv({ commit }, form) {
    const headers = {
      accept: 'text/plain',
    };
    const data = await post('/contract_statistics/influencers/csv', form, { commit }, headers, 'blob');
    return data;
  },
  async doCreateContractTemplate({ commit }, form) {
    commit('error', null);
    commit('setSuccess', null);
    try {
      await post('/contract_templates', form, { commit });
    } catch (e) {
      commit('error', e);
    }
  },
  async doUpdateContractTemplate({ commit }, form) {
    commit('error', null);
    try {
      const { id, title, body } = form;
      await patch(`/contract_templates/${id}`, { title, body }, { commit });
    } catch (e) {
      commit('error', e);
    }
  },
  async doDeleteContractTemplate(context, form) {
    context.commit('error', null);
    try {
      const contractIndex = context.state.contracts.findIndex(c => c.id === form.id);
      const auxContracts = [...context.state.contracts];
      auxContracts.splice(contractIndex, 1);
      context.commit('setContractsTemplates', auxContracts);
      await del(`/contract_templates/${form.id}`, { commit: context.commit });
    } catch (e) {
      context.commit('error', e);
    }
  },
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
